// extracted by mini-css-extract-plugin
export var closeButton = "_dy-1";
export var closeX = "_dy-3";
export var container = "_dy-0";
export var image = "_dy-2";